import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-setting-credit',
  templateUrl: './setting-credit.component.html',
  styleUrls: ['./setting-credit.component.scss']
})
export class SettingCreditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
